/**
 * @author octopaas
 * @since April-2018
 */
import React from 'react';
import '../../../css/login.css';
import {LocalForm} from 'react-redux-form';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {submitResendLink} from '../../actions/actions';
import stringifyQuery from 'query-string-for-all'
import {withRouter} from "react-router";

class ResendVerificationLinkForm extends React.Component {

  render() {
    const {title, message, submitLabel, submitResendLink, token, challenge} = this.props;
    const locationURL = this.props.location;
    const stringQuery = (locationURL) ? stringifyQuery.parse(locationURL.search) : {};
    let resetToken = stringQuery.magic_token;

    return (
        <div key="ResendVerificationLinkForm_1">
          <LocalForm model="loginForm" className="login-form" onSubmit={()=>submitResendLink(token, resetToken, challenge)}>
            <div className="time" />
            <h4 className="informative-title">{title}</h4>
            <div className="message resend-link-message"> {message}</div>
            <button className="wdc-btn wdc-btn-primary">{submitLabel}</button>
          </LocalForm>
        </div>
    );
  }
}

ResendVerificationLinkForm.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  submitResendLink: PropTypes.func,
  submitLabel: PropTypes.string,
  token: PropTypes.string,
  challenge: PropTypes.string,
  location: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    title: state.login.challengeResponse.title,
    message: state.login.challengeResponse.prompts.message.value,
    submitLabel: state.login.challengeResponse.submitLabel,
    token: state.login.token,
    challenge: state.login.challengeResponse.nextChallenge
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    submitResendLink: (token, resetToken, challenge) => {
      dispatch(submitResendLink(token, resetToken, challenge));
    }
  }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResendVerificationLinkForm));
